<script>
    import { createEventDispatcher, onMount } from "svelte";
    import EditableSection from "../EditableSection.svelte";
    import Select from "../ui/Select.svelte";
    import SelectFederalState from "../ui/SelectFederalState.svelte";
    import TextInput from "../ui/TextInput.svelte";
    import Coordinates from "./Coordinates.svelte";

    const dispatch = createEventDispatcher();
    
    export let address;
    export let location;
    address = address ?? {};
    
    const states = [
        {id: "bw", name: "Baden-Württemberg"},
        {id: "by", name: "Bayern"},
        {id: "be", name: "Berlin"},
        {id: "bb", name: "Brandenburg"},
        {id: "hb", name: "Bremen"},
        {id: "hh", name: "Hamburg"},
        {id: "he", name: "Hessen"},
        {id: "mv", name: "Mecklenburg-Vorpommern"},
        {id: "ni", name: "Niedersachsen"},
        {id: "nw", name: "Nordrhein-Westphalen"},
        {id: "rp", name: "Rheinland-Pfalz"},
        {id: "sl", name: "Saarland"},
        {id: "sn", name: "Sachsen"},
        {id: "st", name: "Sachsen-Anhalt"},
        {id: "sh", name: "Schleswig-Holstein"},
        {id: "th", name: "Thüringen"},
    ]
    
    function workaround () {
        dispatch("edit");
        let selectedStates = states.filter((state) => {return state.id === address?.state?.id});
        if(selectedStates.length > 0) {
            address.state = selectedStates[0];
        }
    }
    
    function save () {
        dispatch("save");
    }
</script>


<EditableSection title="Adresse" on:save={save} on:edit={workaround}>
    <div slot="edit">
        <TextInput
            label="Straße"
            bind:value={address.street}
        />
        <TextInput
            label="Hausnummer"
            bind:value={address.houseNumber}
        />
        <TextInput
            label="Adresszusatz"
            bind:value={address.addition}
        />
        <TextInput
            label="Stadt"
            bind:value={address.city}
        />
        <TextInput
            label="PLZ"
            bind:value={address.zip}
        />
        <!-- <Select
            label="Frucht"
            options={[undefined, "Orange", "Zitrone", "Apfel"]}
        /> -->
        <SelectFederalState
            bind:selected={address.state}
        />
        <!-- <label>Bundesland
            <select bind:value={address.state}>
                <option value={{}}> - </option>
                {#each states as state}
                    <option selected={state.id == address?.state?.id} value={state}>{state.name}</option>
                {/each}
            </select>
        </label> -->
    </div>
    <div slot="view">
        <span>{address.street??""} {address.houseNumber??""}</span><br>
        <span>{address.addition??""}</span><br>
        <span>{address.zip??""} {address.city??""}</span><br>
        <span>{address.state?.name??""}</span><br>
        {#if !location.geohash}
            <span class="warning">Es konnten keine Koordinaten für diese Adresse gefunden werden.</span>
        {/if}
    </div>
</EditableSection>

<style>
    .warning {
        display: inline-block;
        margin-top: 1rem;
        padding: 0.2rem 0.4rem;
        border-radius: 0.5rem;
        background-color: rgb(255, 228, 140);
        color: saddlebrown;
    }
</style>